import React from 'react';
import './Button.css';

/**
 * Unified Button Component
 * Variants: primary, secondary, success, danger, ghost, outline
 * Sizes: sm, md, lg
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled = false,
  loading = false,
  onClick,
  className = '',
  icon,
  fullWidth = false,
  ...props
}) => {
  const baseClass = 'cyber-btn';
  const variantClass = `cyber-btn--${variant}`;
  const sizeClass = `cyber-btn--${size}`;
  const fullWidthClass = fullWidth ? 'cyber-btn--full-width' : '';
  const disabledClass = disabled || loading ? 'cyber-btn--disabled' : '';

  const classes = [
    baseClass,
    variantClass,
    sizeClass,
    fullWidthClass,
    disabledClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="cyber-btn__spinner"></span>}
      {icon && !loading && <span className="cyber-btn__icon">{icon}</span>}
      <span className="cyber-btn__text">{children}</span>
    </button>
  );
};

export default Button;
